export default "__VITE_ASSET__BbKWYB9q__"